import React, { useContext } from 'react';
import { KFLKeyValue } from '@kamstrup/kamstrup-frontend-library';
import * as DeviceInfo from '../../modules/dialogs/deviceInfo/model';
import * as Devices from '../../modules/devices';
import { AppKeys } from '../../core/localization';
import { LocaleCtx } from '../../contexts/locale.context';

interface OwnProps {
  item: DeviceInfo.Item;
}
type Props = OwnProps;
const DeviceInfoItemStatus: React.FC<Props> = ({ item }) => {
  const { translate } = useContext(LocaleCtx);
  const fields = [
    {
      key: translate(AppKeys.Device_Prop_Owner),
      orientation: 'horisontal' as 'horisontal',
      value: String(item.owner),
    },
    {
      key: translate(AppKeys.Device_Prop_EditRights),
      value: String(item.userWithReadRights || '-'),
    },
    {
      key: translate(AppKeys.Device_Prop_Availability),
      value: translate(Devices.AvailabilityLevelDisplay[item.availability]),
    },
    {
      key: translate(AppKeys.sidebar_devices_status_header),
      value: translate(Devices.msgStatusValue(item.isActive)),
    },
  ];
  return (
    <div>
      <KFLKeyValue keyValuePairs={fields} />
    </div>
  );
};

export default DeviceInfoItemStatus;
